import { REDUCERS } from '../../constants/reducers';

const initialState = {
  loading: false,
  configurations: []
};

const tableConfigurations = (state = initialState, action) => {
  switch (action.type) {
    case REDUCERS.TABLE_CONFIGURATIONS.SET_CONFIGURATIONS:
      return {
        ...state,
        configurations: action.value
      };

    case REDUCERS.TABLE_CONFIGURATIONS.SET_CONFIGURATIONS_LOADING:
      return { ...state, loading: action.value };

    case REDUCERS.RESET:
      return initialState;

    default:
      return state;
  }
};

export { tableConfigurations };
